// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__c9EDP","messages":"Chat_messages__149fU","dateDivider":"Chat_dateDivider__3rBQV"};